import type { FC } from 'react';
import styles from '../styles/page-title.module.scss';

const PageTitle: FC<{ title: string }> = ({ title }) => {
    return <div className={styles.pageTitle}>{title}</div>;
};

export default PageTitle;
